import { render, staticRenderFns } from "./BusinessPageDetails.vue?vue&type=template&id=98278878&"
import script from "./BusinessPageDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessPageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports